import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  OutlinedInput,
  MenuItem,
  FormControl,
  Select,
  InputAdornment,
  IconButton,
  TextField,
  ListSubheader,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { FixedSizeList } from "react-window";

const ITEM_HEIGHT = 36;
const MAX_VISIBLE_ITEMS = 8;

const SingleSelectSKU = (props) => {
  debugger;
  const customerData = props?.getSKUbyCountry;
  const disabled = props?.disabled;
  const selectedSwitchedSKUName = props?.selectedSwitchedSKUName;
  const customers = useMemo(
    () => [...new Set(customerData.map((item) => item.name))],
    [customerData]
  );

  const [customerName, setCustomerName] = useState(selectedSwitchedSKUName);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(customers);
  const textInput = useRef(null);

  const handleChange = (event) => {
    debugger;
    const value = event.target.value;
    setCustomerName(value);
    props.sendDataToParent(value);
  };

  useEffect(() => {
    setFilteredData(customers);
  }, [customers]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        const filtered = customers.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredData(filtered);
      } else {
        setFilteredData(customers);
      }

      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText, customers]);

  // const Row = ({ index, style }) => (
  //   <MenuItem style={style} key={index} value={filteredData[index]}>
  //     {filteredData[index]}
  //   </MenuItem>
  // );

  
const Row = ({ index, style }) => {
  const value = filteredData[index];
  return (
    <MenuItem
      style={style}
      key={index}
      value={value}
      onClick={() => {
        setCustomerName(value);
        props.sendDataToParent(value);
      }}
    >
      {value}
    </MenuItem>
  );
};


  return (
    <FormControl fullWidth>
      <Select
        value={customerName}
        onChange={handleChange}
        size="small"
        disabled={disabled}
        input={<OutlinedInput />}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: ITEM_HEIGHT * MAX_VISIBLE_ITEMS + 10,
              overflow: "hidden",
            },
          },
        }}
        renderValue={(selected) => selected || ""}
      >
        <ListSubheader>
          <TextField
            size="small"
            inputRef={textInput}
            value={searchText}
            placeholder="Search..."
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setSearchText("")}>
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>

        <FixedSizeList
          height={Math.min(filteredData.length, MAX_VISIBLE_ITEMS) * ITEM_HEIGHT}
          itemCount={filteredData.length}
          itemSize={ITEM_HEIGHT}
          width="100%"
        >
          {Row}
        </FixedSizeList>
      </Select>
    </FormControl>
  );
};

export default SingleSelectSKU;
